var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftLid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 180.101,
    height: 242.554,
    viewBox: "0 0 180.101 242.554",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 180.101,
    height: 242.554,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(24 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476",
    transform: "translate(-23.999 11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M59.909,65.585c-1.827.311-3.292.534-4.3.676l-9.5-12.924C51.841,41.279,72.269,1.82,94.98.063c5.673-.434,13.879,1.173,20.762,11.309,7.012,10.32,5.619,18.949,3.217,24.372-8.608,19.429-44.777,27.409-59.05,29.842M67.63,47.31c13.974-3.8,42.811-13.275,33.048-25.706C92.022,10.585,76.074,33.672,67.63,47.31",
    transform: "translate(36.308 0)",
    fill: "#d5a457"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M11.125,52.023c-4.061-4.32-8.233-12-5.035-24.065C9.229,16.115,16.441,11.885,21.935,10.415,43.948,4.551,76.29,35.02,85.685,44.5L81,59.841c-.994.2-2.45.475-4.277.785A183.573,183.573,0,0,1,56.956,62.9c-16.058.946-36-.425-45.83-10.874m12.569-19.4c-5.1,14.962,25.25,14.352,39.7,13.312-12.483-10.074-35.177-26.576-39.7-13.312",
    transform: "translate(3.902 7.616)",
    fill: "#d5a457"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M152.359,199.015",
    transform: "translate(8.246 43.54)",
    fill: "#ff3d02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M23.334,143.716h0Z",
    transform: "translate(84.242 98.839)",
    fill: "#d5a457"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M154.383,23.334h0Z",
    transform: "translate(18.718 153.697)",
    fill: "#d5a457"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M175.3,54.533,10.107,82.68a5.766,5.766,0,0,1-6.651-4.715L.083,58.162A5.763,5.763,0,0,1,4.8,51.513l165.2-28.147a5.765,5.765,0,0,1,6.651,4.713l3.373,19.8a5.762,5.762,0,0,1-4.713,6.651",
    transform: "translate(-0.001 18.332)",
    fill: "#ff3d02"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 23.333,
    height: 31.617,
    transform: "translate(75.894 57.73) rotate(-9.671)",
    fill: "#d5a457"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftLid);
export default __webpack_public_path__ + "static/media/gift-lid.2148c2f98d59049d10de2decb63fac5d.svg";
export { ForwardRef as ReactComponent };